import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import api from "../Api";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import Popup from '../components/PopUP';


export default function AircraftDetail(){

    const { id } = useParams();
    const [aircraftDetails, setAircraftDetails] = useState({});
    const [popupMessage, setPopupMessage] = useState("Loading Aircraft details...");
    const [loading, setLoading] = useState(true);

    useEffect(() => {
    const fetchAircraftDetails = async () => {
      setLoading(true);
      try {
        const response = await api.get(`/airplane-service/aircraft/details/${id}`);
        console.log("aircraft Details:", response.data);
        setAircraftDetails(response.data);
        setPopupMessage("Aircraft details loaded successfully");
      } catch (error) {
        console.error("Error fetching aircraft details:", error);
        setPopupMessage("Error loading aircraft details");
      }
      setLoading(false);
    };

    fetchAircraftDetails();
  }, [id]);


    return (
    <>
     <>
      <Popup message={popupMessage} onClose={() => setPopupMessage("")} />
      <Sidebar />
      <div className="main-wrapper">
        <Header />
        <div className="content-wrapper">
      <section className="main-section spacer-y">
        <div className="container">
          <div className="row gy-4">
            <div className="col-xl-12">
              <div className="common_main_bg_wrapper">
                <div className="common_main_heading_wrapper">
                  <div className="vstack">
                    <nav className="breadcrumb_nav">
                      <ul className="breadcrumb mb-0">
                        <li className="breadcrumb-item">
                          <a href="dashboard.html">Dashboard</a>
                        </li>
                        <li className="breadcrumb-item">
                          <Link to="/manufacturer">Aircraft Management</Link>
                        </li>
                        <li className="breadcrumb-item text-capitalize">Aircraft Detail</li>
                      </ul>
                    </nav>
                    <h1>Aircraft Detail - Antonov An-148</h1>
                  </div>
                </div>
              </div>
              <div className="outline_tab_card mt-4">
                <nav>
                  <div className="nav nav-tabs" id="nav-tab" role="tablist">
                    <button
                      className="nav-link active"
                      id="nav-1-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#nav-1"
                      type="button"
                      role="tab"
                      aria-controls="nav-1"
                      aria-selected="true"
                    >
                      General Details
                    </button>
                    <button
                      className="nav-link d-none"
                      id="nav-2-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#nav-2"
                      type="button"
                      role="tab"
                      aria-controls="nav-2"
                      aria-selected="false"
                    >
                      Company Details
                    </button>
                    <button
                      className="nav-link d-none"
                      id="nav-3-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#nav-3"
                      type="button"
                      role="tab"
                      aria-controls="nav-3"
                      aria-selected="false"
                    >
                      Products
                    </button>
                    <button
                      className="nav-link "
                      id="nav-4-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#nav-4"
                      type="button"
                      role="tab"
                      aria-controls="nav-4"
                      aria-selected="false"
                    >
                      Images
                    </button>
                    <button
                      className="nav-link"
                      id="nav-5-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#nav-5"
                      type="button"
                      role="tab"
                      aria-controls="nav-5"
                      aria-selected="false"
                    >
                      Powerplant & Propulsion
                    </button>
                    <button
                      className="nav-link"
                      id="nav-6-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#nav-6"
                      type="button"
                      role="tab"
                      aria-controls="nav-6"
                      aria-selected="false"
                    >
                      Dimensions
                    </button>
                    <button
                      className="nav-link"
                      id="nav-7-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#nav-7"
                      type="button"
                      role="tab"
                      aria-controls="nav-7"
                      aria-selected="false"
                    >
                      Weights
                    </button>
                    <button
                      className="nav-link"
                      id="nav-8-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#nav-8"
                      type="button"
                      role="tab"
                      aria-controls="nav-8"
                      aria-selected="false"
                    >
                      Performance
                    </button>
                    <button
                      className="nav-link"
                      id="nav-9-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#nav-9"
                      type="button"
                      role="tab"
                      aria-controls="nav-9"
                      aria-selected="false"
                    >
                      Operational Limitations
                    </button>
                    <button
                      className="nav-link"
                      id="nav-10-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#nav-10"
                      type="button"
                      role="tab"
                      aria-controls="nav-10"
                      aria-selected="false"
                    >
                      Landing Gear
                    </button>
                    <button
                      className="nav-link"
                      id="nav-11-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#nav-11"
                      type="button"
                      role="tab"
                      aria-controls="nav-11"
                      aria-selected="false"
                    >
                      Certification & Environmental
                    </button>
                  </div>
                </nav>
              </div>
              {loading ? (
                <div>Loading...</div>
              ) : (
                <div className="tab_blk">
                  <div className="tab-content" id="nav-tabContent">
                    {/* General Details Tab */}
                    <div
                      className="tab-pane fade show active"
                      id="nav-1"
                      role="tabpanel"
                      aria-labelledby="nav-1-tab"
                      tabIndex="0"
                    >
                      <div className="common-outer-card">
                        <div className="common_sub_heading_wrapper">
                          <h2>General Information</h2>
                        </div>
                        <div className="common_content_blk">
                          <div className="box_card manufacturer_profile_card common-card">
                            <div className="box_detail_blk">
                              <div className="box_info_list">
                                <div className="box_info_context">
                                  <p className="box_info_title">Manufacturer</p>
                                  <p className="box_info_data text-capitalize">
                                    {aircraftDetails.results?.IdentificationClassification.Manufacturer}
                                  </p>
                                </div>
                                <div className="box_info_context">
                                  <p className="box_info_title">Aircraft Model</p>
                                  <p className="box_info_data">
                                    {aircraftDetails.results?.IdentificationClassification.Aircraft_Model}
                                  </p>
                                </div>
                                <div className="box_info_context">
                                  <p className="box_info_title">Country of Origin</p>
                                  <p className="box_info_data">
                                    {aircraftDetails.results?.IdentificationClassification.Country_of_Origin}
                                  </p>
                                </div>
                                <div className="box_info_context">
                                  <p className="box_info_title">Date of Maiden Flight</p>
                                  <p className="box_info_data">
                                    {aircraftDetails.results?.IdentificationClassification.Date_of_Maiden_Flight}
                                  </p>
                                </div>
                                <div className="box_info_context">
                                  <p className="box_info_title">Year of Introduction</p>
                                  <p className="box_info_data">
                                    {aircraftDetails.results?.IdentificationClassification.Year_of_Introduction}
                                  </p>
                                </div>
                                <div className="box_info_context">
                                  <p className="box_info_title">Production Status</p>
                                  <p className="box_info_data">
                                    {aircraftDetails.results?.IdentificationClassification.Production_Status}
                                  </p>
                                </div>
                                <div className="box_info_context">
                                  <p className="box_info_title">Avionics System</p>
                                  <p className="box_info_data">
                                    {aircraftDetails.results?.IdentificationClassification.Avionics_System}
                                  </p>
                                </div>
                                <div className="box_info_context">
                                  <p className="box_info_title">Number of Crew</p>
                                  <p className="box_info_data">
                                    {aircraftDetails.results?.IdentificationClassification.Number_of_Crew}
                                  </p>
                                </div>
                                <div className="box_info_context">
                                  <p className="box_info_title">Passenger Capacity</p>
                                  <p className="box_info_data">
                                    Typical: {aircraftDetails.results?.IdentificationClassification.Number_of_Passengers.Typical}, 
                                    Maximum: {aircraftDetails.results?.IdentificationClassification.Number_of_Passengers.Maximum}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* Company Details Tab */}
                    <div
                      className="tab-pane fade"
                      id="nav-2"
                      role="tabpanel"
                      aria-labelledby="nav-2-tab"
                      tabIndex="0"
                    >
                      <div className="common-outer-card">
                        <div className="common_sub_heading_wrapper">
                          <h2>Company Information</h2>
                        </div>
                        <div className="common_content_blk">
                          <div className="box_card manufacturer_profile_card common-card">
                            <div className="box_detail_blk">
                              <div className="box_info_list">
                                <div className="box_info_context">
                                  <p className="box_info_title">Company Description</p>
                                  <p className="box_info_data">
                                    {aircraftDetails.data?.company.company_description}
                                  </p>
                                </div>
                                <div className="box_info_context">
                                  <p className="box_info_title">Company History</p>
                                  <p className="box_info_data">
                                    {aircraftDetails.data?.company.company_history}
                                  </p>
                                </div>
                                <div className="box_info_context">
                                  <p className="box_info_title">Interesting Facts</p>
                                  <p className="box_info_data">
                                    {aircraftDetails.data?.company.interesting_facts.join(' ')}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* Products Tab */}
                    <div
                      className="tab-pane fade"
                      id="nav-3"
                      role="tabpanel"
                      aria-labelledby="nav-3-tab"
                      tabIndex="0"
                    >
                      <div className="common-outer-card">
                        <div className="common_sub_heading_wrapper">
                          <h2>Products</h2>
                        </div>
                        {aircraftDetails.data?.product.map((product, index) => (
                          <div className="common_content_blk" key={index}>
                            <div className="box_card manufacturer_profile_card common-card">
                              <div className="box_detail_blk">
                                <div className="box_info_list">
                                  <div className="box_info_context">
                                    <p className="box_info_title">Series</p>
                                    <p className="box_info_data text-capitalize">
                                      {product.series.trim()}
                                    </p>
                                  </div>
                                  <div className="box_info_context">
                                    <p className="box_info_title">Description</p>
                                    <p className="box_info_data">{product.description}</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                    {/* Images Tab */}
                    <div
                      className="tab-pane fade"
                      id="nav-4"
                      role="tabpanel"
                      aria-labelledby="nav-4-tab"
                      tabIndex="0"
                    >
                      <div className="common-outer-card">
                        <div className="common_sub_heading_wrapper">
                          <h2>Images</h2>
                        </div>
                        <div className="common_content_blk">
                          <div className="box_card manufacturer_profile_card common-card">
                            <div className="box_detail_blk">
                              <div className="box_info_list">
                                <div className="box_info_context">
                                  <p className="box_info_title">Aircraft Images</p>
                                  <p className="box_info_data">
                                    {aircraftDetails.results?.Images.map((image, index) => (
                                      <div key={index} style={{ marginBottom: '10px' }}>
                                        <img
                                          src={image.url}
                                          alt="Aircraft logo"
                                          style={{ width: '30%', marginRight: '10px' }}
                                          className="rounded"
                                        />
                                        <span>
                                          {image.cc ? `© ${image.cc}` : 'No attribution'}
                                          {image.source && (
                                            <a href={image.source} target="_blank" rel="noopener noreferrer">
                                              {' (Source)'}
                                            </a>
                                          )}
                                        </span>
                                      </div>
                                    ))}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* Powerplant & Propulsion Tab */}
                   {/* Powerplant & Propulsion Tab */}
<div
  className="tab-pane fade"
  id="nav-5"
  role="tabpanel"
  aria-labelledby="nav-5-tab"
  tabIndex="0"
>
  <div className="common-outer-card">
    <div className="common_sub_heading_wrapper">
      <h2>Powerplant & Propulsion</h2>
    </div>
    <div className="common_content_blk">
      <div className="box_card manufacturer_profile_card common-card">
        <div className="box_detail_blk">
          <div className="box_info_list">
            <div className="box_info_context">
              <p className="box_info_title">Number of Engines</p>
              <p className="box_info_data">
                {aircraftDetails.results?.PowerplantPropulsion.Number_of_Engines}
              </p>
            </div>
            <div className="box_info_context">
              <p className="box_info_title">Engine Manufacturer</p>
              <p className="box_info_data">
                {aircraftDetails.results?.PowerplantPropulsion.Engine.Manufacturer}
              </p>
            </div>
            <div className="box_info_context">
              <p className="box_info_title">Engine Model</p>
              <p className="box_info_data">
                {aircraftDetails.results?.PowerplantPropulsion.Engine.Model}
              </p>
            </div>
            <div className="box_info_context">
              <p className="box_info_title">Engine Type</p>
              <p className="box_info_data">
                {aircraftDetails.results?.PowerplantPropulsion.Engine.Engine_Type}
              </p>
            </div>
            <div className="box_info_context">
              <p className="box_info_title">Thrust per Engine</p>
              <p className="box_info_data">
                {aircraftDetails.results?.PowerplantPropulsion.Engine.Thrust_Per_Engine_kN_or_kW}
              </p>
            </div>
            <div className="box_info_context">
              <p className="box_info_title">APU Type</p>
              <p className="box_info_data">
                {aircraftDetails.results?.PowerplantPropulsion.APU_Type}
              </p>
            </div>
            <div className="box_info_context">
              <p className="box_info_title">Fuel Type</p>
              <p className="box_info_data">
                {aircraftDetails.results?.PowerplantPropulsion.Fuel.Fuel_Type}
              </p>
            </div>
            <div className="box_info_context">
              <p className="box_info_title">Fuel Capacity</p>
              <p className="box_info_data">
                {aircraftDetails.results?.PowerplantPropulsion.Fuel.Capacity_L_or_kg} kg
              </p>
            </div>
            <div className="box_info_context">
              <p className="box_info_title">Fuel Burn (Cruise)</p>
              <p className="box_info_data">
                {aircraftDetails.results?.PowerplantPropulsion.Fuel.Fuel_Burn_Cruise_kg_per_hr} kg/hr
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

                    {/* Dimensions Tab */}
                    <div
                    className="tab-pane fade"
                    id="nav-6"
                    role="tabpanel"
                    aria-labelledby="nav-6-tab"
                    tabIndex="0"
                    >
                    <div className="common-outer-card">
                        <div className="common_sub_heading_wrapper">
                        <h2>Dimensions</h2>
                        </div>
                        <div className="common_content_blk">
                        <div className="box_card manufacturer_profile_card common-card">
                            <div className="box_detail_blk">
                            <div className="box_info_list">
                                <div className="box_info_context">
                                <p className="box_info_title">Wingspan</p>
                                <p className="box_info_data">
                                    {aircraftDetails.results?.Dimensions.Wingspan_m} m
                                </p>
                                </div>
                                <div className="box_info_context">
                                <p className="box_info_title">Length</p>
                                <p className="box_info_data">
                                    {aircraftDetails.results?.Dimensions.Length_m} m
                                </p>
                                </div>
                                <div className="box_info_context">
                                <p className="box_info_title">Height</p>
                                <p className="box_info_data">
                                    {aircraftDetails.results?.Dimensions.Height_m} m
                                </p>
                                </div>
                                <div className="box_info_context">
                                <p className="box_info_title">Wing Area</p>
                                <p className="box_info_data">
                                    {aircraftDetails.results?.Dimensions.Wing_Area_m2} m²
                                </p>
                                </div>
                                <div className="box_info_context">
                                <p className="box_info_title">Cabin Width</p>
                                <p className="box_info_data">
                                    {aircraftDetails.results?.Dimensions.Cabin_Width_m} m
                                </p>
                                </div>
                                <div className="box_info_context">
                                <p className="box_info_title">Door Height</p>
                                <p className="box_info_data">
                                    {aircraftDetails.results?.Dimensions.Door_Height_m} m
                                </p>
                                </div>
                                <div className="box_info_context">
                                <p className="box_info_title">Wingtip Configuration</p>
                                <p className="box_info_data">
                                    {aircraftDetails.results?.Dimensions.Wingtip_Configuration}
                                </p>
                                </div>
                            </div>
                            </div>
                        </div>
                        </div>
                    </div>
                    </div>

                    {/* Weights Tab */}
                    <div
                    className="tab-pane fade"
                    id="nav-7"
                    role="tabpanel"
                    aria-labelledby="nav-7-tab"
                    tabIndex="0"
                    >
                    <div className="common-outer-card">
                        <div className="common_sub_heading_wrapper">
                        <h2>Weights</h2>
                        </div>
                        <div className="common_content_blk">
                        <div className="box_card manufacturer_profile_card common-card">
                            <div className="box_detail_blk">
                            <div className="box_info_list">
                                <div className="box_info_context">
                                <p className="box_info_title">Operating Empty Weight</p>
                                <p className="box_info_data">
                                    {aircraftDetails.results?.Weights.Operating_Empty_Weight_kg} kg
                                </p>
                                </div>
                                <div className="box_info_context">
                                <p className="box_info_title">Maximum Zero Fuel Weight</p>
                                <p className="box_info_data">
                                    {aircraftDetails.results?.Weights.Maximum_Zero_Fuel_Weight_kg} kg
                                </p>
                                </div>
                                <div className="box_info_context">
                                <p className="box_info_title">Maximum Takeoff Weight</p>
                                <p className="box_info_data">
                                    {aircraftDetails.results?.Weights.Maximum_Takeoff_Weight_kg} kg
                                </p>
                                </div>
                                <div className="box_info_context">
                                <p className="box_info_title">Maximum Payload</p>
                                <p className="box_info_data">
                                    {aircraftDetails.results?.Weights.Maximum_Payload_kg} kg
                                </p>
                                </div>
                                <div className="box_info_context">
                                <p className="box_info_title">Maximum Landing Weight</p>
                                <p className="box_info_data">
                                    {aircraftDetails.results?.Weights.Maximum_Landing_Weight_kg} kg
                                </p>
                                </div>
                                <div className="box_info_context">
                                <p className="box_info_title">Baggage/Cargo Volume</p>
                                <p className="box_info_data">
                                    {aircraftDetails.results?.Weights.Baggage_or_Cargo_Volume.Minimum_m3}–
                                    {aircraftDetails.results?.Weights.Baggage_or_Cargo_Volume.Maximum_m3} m³
                                </p>
                                </div>
                            </div>
                            </div>
                        </div>
                        </div>
                    </div>
                    </div>

                    {/* Performance Tab */}
                    <div
                        className="tab-pane fade"
                        id="nav-8"
                        role="tabpanel"
                        aria-labelledby="nav-8-tab"
                        tabIndex="0"
                        >
                        <div className="common-outer-card">
                            <div className="common_sub_heading_wrapper">
                            <h2>Performance</h2>
                            </div>
                            <div className="common_content_blk">
                            <div className="box_card manufacturer_profile_card common-card">
                                <div className="box_detail_blk">
                                <div className="box_info_list">
                                    <div className="box_info_context">
                                    <p className="box_info_title">Takeoff Speed</p>
                                    <p className="box_info_data">
                                        {aircraftDetails.results?.Performance.Takeoff_Speed_kts} kts
                                    </p>
                                    </div>
                                    <div className="box_info_context">
                                    <p className="box_info_title">Takeoff Distance</p>
                                    <p className="box_info_data">
                                        {aircraftDetails.results?.Performance.Takeoff_Distance_m} m
                                    </p>
                                    </div>
                                    <div className="box_info_context">
                                    <p className="box_info_title">Initial Climb Rate</p>
                                    <p className="box_info_data">
                                        {aircraftDetails.results?.Performance.Initial_Climb_Rate_fpm} fpm
                                    </p>
                                    </div>
                                    <div className="box_info_context">
                                    <p className="box_info_title">Average Climb Rate</p>
                                    <p className="box_info_data">
                                        {aircraftDetails.results?.Performance.Average_Rate_of_Climb_fpm} fpm
                                    </p>
                                    </div>
                                    <div className="box_info_context">
                                    <p className="box_info_title">Service Ceiling</p>
                                    <p className="box_info_data">
                                        {aircraftDetails.results?.Performance.Service_Ceiling_ft} ft
                                    </p>
                                    </div>
                                    <div className="box_info_context">
                                    <p className="box_info_title">Cruise Speed</p>
                                    <p className="box_info_data">
                                        {aircraftDetails.results?.Performance.Cruise_Speed_kt}
                                    </p>
                                    </div>
                                    <div className="box_info_context">
                                    <p className="box_info_title">Maximum Cruise Speed</p>
                                    <p className="box_info_data">
                                        {aircraftDetails.results?.Performance.Maximum_Cruise_Speed_kts_or_Mach}
                                    </p>
                                    </div>
                                    <div className="box_info_context">
                                    <p className="box_info_title">VMO</p>
                                    <p className="box_info_data">
                                        {aircraftDetails.results?.Performance.VMO_kts} kts
                                    </p>
                                    </div>
                                    <div className="box_info_context">
                                    <p className="box_info_title">MMO</p>
                                    <p className="box_info_data">
                                        {aircraftDetails.results?.Performance.MMO_Mach}
                                    </p>
                                    </div>
                                    <div className="box_info_context">
                                    <p className="box_info_title">Range</p>
                                    <p className="box_info_data">
                                        Normal: {aircraftDetails.results?.Performance.Range.Normal_Range_NM} NM, 
                                        Ferry: {aircraftDetails.results?.Performance.Range.Ferry_Range_NM} NM
                                    </p>
                                    </div>
                                    <div className="box_info_context">
                                    <p className="box_info_title">Initial Descent Rate</p>
                                    <p className="box_info_data">
                                        {aircraftDetails.results?.Performance.Initial_Rate_of_Descent_fpm} fpm
                                    </p>
                                    </div>
                                    <div className="box_info_context">
                                    <p className="box_info_title">Average Descent Rate</p>
                                    <p className="box_info_data">
                                        {aircraftDetails.results?.Performance.Average_Rate_of_Descent_fpm} fpm
                                    </p>
                                    </div>
                                    <div className="box_info_context">
                                    <p className="box_info_title">Minimum Clean Speed</p>
                                    <p className="box_info_data">
                                        {aircraftDetails.results?.Performance.Minimum_Clean_Speed_kts} kts
                                    </p>
                                    </div>
                                    <div className="box_info_context">
                                    <p className="box_info_title">Approach Speed</p>
                                    <p className="box_info_data">
                                        {aircraftDetails.results?.Performance.Approach_Speed_kts} kts
                                    </p>
                                    </div>
                                    <div className="box_info_context">
                                    <p className="box_info_title">Approach Category</p>
                                    <p className="box_info_data">
                                        {aircraftDetails.results?.Performance.Approach_Category}
                                    </p>
                                    </div>
                                    <div className="box_info_context">
                                    <p className="box_info_title">Landing Speed</p>
                                    <p className="box_info_data">
                                        {aircraftDetails.results?.Performance.Landing_Speed_kts} kts
                                    </p>
                                    </div>
                                    <div className="box_info_context">
                                    <p className="box_info_title">Landing Distance</p>
                                    <p className="box_info_data">
                                        {aircraftDetails.results?.Performance.Landing_Distance_m} m
                                    </p>
                                    </div>
                                    <div className="box_info_context">
                                    <p className="box_info_title">Runway Length Required</p>
                                    <p className="box_info_data">
                                        {aircraftDetails.results?.Performance.Runway_Length_Required_m} m
                                    </p>
                                    </div>
                                    <div className="box_info_context">
                                    <p className="box_info_title">Stall Speed</p>
                                    <p className="box_info_data">
                                        {aircraftDetails.results?.Performance.Stall_Speed_kts} kts
                                    </p>
                                    </div>
                                </div>
                                </div>
                            </div>
                            </div>
                        </div>
                        </div>

                    {/* Operational Limitations Tab */}
                <div
                className="tab-pane fade"
                id="nav-9"
                role="tabpanel"
                aria-labelledby="nav-9-tab"
                tabIndex="0"
                >
                <div className="common-outer-card">
                    <div className="common_sub_heading_wrapper">
                    <h2>Operational Limitations</h2>
                    </div>
                    <div className="common_content_blk">
                    <div className="box_card manufacturer_profile_card common-card">
                        <div className="box_detail_blk">
                        <div className="box_info_list">
                            <div className="box_info_context">
                            <p className="box_info_title">Runway Slope Limit</p>
                            <p className="box_info_data">
                                {aircraftDetails.results?.OperationalLimitations.Runway_Slope_Limit_percent} %
                            </p>
                            </div>
                            <div className="box_info_context">
                            <p className="box_info_title">Max Crosswind (Normal Law)</p>
                            <p className="box_info_data">
                                {aircraftDetails.results?.OperationalLimitations.Max_Crosswind_Normal_Law_kts} kts
                            </p>
                            </div>
                            <div className="box_info_context">
                            <p className="box_info_title">Max Crosswind (Degraded Law)</p>
                            <p className="box_info_data">
                                {aircraftDetails.results?.OperationalLimitations.Max_Crosswind_Degraded_Law_kts} kts
                            </p>
                            </div>
                            <div className="box_info_context">
                            <p className="box_info_title">Max Tailwind (Landing)</p>
                            <p className="box_info_data">
                                {aircraftDetails.results?.OperationalLimitations.Max_Tailwind_Landing_kts} kts
                            </p>
                            </div>
                            <div className="box_info_context">
                            <p className="box_info_title">Max Tailwind (Takeoff)</p>
                            <p className="box_info_data">
                                {aircraftDetails.results?.OperationalLimitations.Max_Tailwind_Takeoff_kts} kts
                            </p>
                            </div>
                            <div className="box_info_context">
                            <p className="box_info_title">Field Elevation Limit</p>
                            <p className="box_info_data">
                                {aircraftDetails.results?.OperationalLimitations.Field_Elevation_Limit_ft} ft
                            </p>
                            </div>
                            <div className="box_info_context">
                            <p className="box_info_title">Max Runway Altitude</p>
                            <p className="box_info_data">
                                {aircraftDetails.results?.OperationalLimitations.Max_Runway_Altitude_ft} ft
                            </p>
                            </div>
                            <div className="box_info_context">
                            <p className="box_info_title">Autoland Capability</p>
                            <p className="box_info_data">
                                Supported: {aircraftDetails.results?.OperationalLimitations.Autoland_Capability.Supported_Categories}, 
                                Certified Level: {aircraftDetails.results?.OperationalLimitations.Autoland_Capability.Certified_Autoland_Level}
                            </p>
                            </div>
                        </div>
                        </div>
                    </div>
                    </div>
                </div>
                </div>

                    {/* Landing Gear Tab */}
                <div
                className="tab-pane fade"
                id="nav-10"
                role="tabpanel"
                aria-labelledby="nav-10-tab"
                tabIndex="0"
                >
                <div className="common-outer-card">
                    <div className="common_sub_heading_wrapper">
                    <h2>Landing Gear</h2>
                    </div>
                    <div className="common_content_blk">
                    <div className="box_card manufacturer_profile_card common-card">
                        <div className="box_detail_blk">
                        <div className="box_info_list">
                            <div className="box_info_context">
                            <p className="box_info_title">Type</p>
                            <p className="box_info_data">
                                {aircraftDetails.results?.LandingGear.Type}
                            </p>
                            </div>
                            <div className="box_info_context">
                            <p className="box_info_title">Number of Wheels</p>
                            <p className="box_info_data">
                                {aircraftDetails.results?.LandingGear.Number_of_Wheels}
                            </p>
                            </div>
                            <div className="box_info_context">
                            <p className="box_info_title">Tyre Size</p>
                            <p className="box_info_data">
                                {aircraftDetails.results?.LandingGear.Tyre_Size_inches}
                            </p>
                            </div>
                            <div className="box_info_context">
                            <p className="box_info_title">Tyre Pressure</p>
                            <p className="box_info_data">
                                {aircraftDetails.results?.LandingGear.Tyre_Pressure_bar_psi}
                            </p>
                            </div>
                        </div>
                        </div>
                    </div>
                    </div>
                </div>
                </div>

                    {/* Certification & Environmental Tab */}
                 <div
                    className="tab-pane fade"
                    id="nav-11"
                    role="tabpanel"
                    aria-labelledby="nav-11-tab"
                    tabIndex="0"
                    >
                    <div className="common-outer-card">
                        <div className="common_sub_heading_wrapper">
                        <h2>Certification & Environmental</h2>
                        </div>
                        <div className="common_content_blk">
                        <div className="box_card manufacturer_profile_card common-card">
                            <div className="box_detail_blk">
                            <div className="box_info_list">
                                <div className="box_info_context">
                                <p className="box_info_title">Certification Basis</p>
                                <p className="box_info_data">
                                    {aircraftDetails.results?.CertificationEnvironmental.Certification_Basis}
                                </p>
                                </div>
                                <div className="box_info_context">
                                <p className="box_info_title">EASA TCDS Number</p>
                                <p className="box_info_data">
                                    {aircraftDetails.results?.CertificationEnvironmental.EASA_TCDS_Number}
                                </p>
                                </div>
                                <div className="box_info_context">
                                <p className="box_info_title">FAA TCDS Number</p>
                                <p className="box_info_data">
                                    {aircraftDetails.results?.CertificationEnvironmental.FAA_TCDS_Number}
                                </p>
                                </div>
                                <div className="box_info_context">
                                <p className="box_info_title">Special Conditions</p>
                                <p className="box_info_data">
                                    {aircraftDetails.results?.CertificationEnvironmental.Special_Conditions}
                                </p>
                                </div>
                                <div className="box_info_context">
                                <p className="box_info_title">Noise Compliance</p>
                                <p className="box_info_data">
                                    {aircraftDetails.results?.CertificationEnvironmental.Noise_Compliance}
                                </p>
                                </div>
                                <div className="box_info_context">
                                <p className="box_info_title">Emissions Category</p>
                                <p className="box_info_data">
                                    {aircraftDetails.results?.CertificationEnvironmental.Emissions_Category}
                                </p>
                                </div>
                            </div>
                            </div>
                        </div>
                        </div>
                    </div>
                    </div>

                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
    </div>
      </div>
    </>
    </>
    )
}

